import { useState } from "react"
import { LoaderFullScreen } from "../../atoms/animations/Loader"
import { spaces } from "../../../utils/styles"
import { useViewport } from "../../../hooks/utils/useViewport"

export const HedgeFundsDashboard = () => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div style={{ margin: spaces.space1 }}>
      {isLoading && <LoaderFullScreen showRandomFacts />}
      <iframe
        src="https://quant.teracapital.com.br/tera-quant-dashboard/"
        style={{ width: "99vw", height: useViewport().height - 170, marginTop: spaces.space1, border: "none" }}
        onLoad={() => setIsLoading(false)}
      />
    </div>
  )
}
